import { render } from "./LabItem.vue?vue&type=template&id=70cb743f&scoped=true"
import script from "./LabItem.vue?vue&type=script&lang=js"
export * from "./LabItem.vue?vue&type=script&lang=js"

import "./LabItem.vue?vue&type=style&index=0&id=70cb743f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70cb743f"]])

export default __exports__